import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { InstallationDetailsStore, LanguageStore, RefrigerationCircuitMessagesStore } from '@store';
import { Observable, combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-refrigerant-circuit-history-modal',
  templateUrl: './refrigerant-circuit-history-modal.component.html',
  styleUrls: ['./refrigerant-circuit-history-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefrigerantCircuitHistoryModalComponent implements OnInit {
  link$: Observable<string>;
  constructor(
    public refrigerationCircuitMessagesStore: RefrigerationCircuitMessagesStore,
    public dialogRef: MatDialogRef<RefrigerantCircuitHistoryModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      boilerSerial: string;
    },
    private languageStore: LanguageStore,
    private installationDetailsStore: InstallationDetailsStore
  ) {}

  ngOnInit(): void {
    this.refrigerationCircuitMessagesStore.getRefrigerationCircuitMessages();

    this.link$ = combineLatest([
      this.installationDetailsStore.device$,
      this.languageStore.languageCode$,
    ]).pipe(
      map(([device, languageCode]) => {
        const serial = device.boilerSerial.slice(0, 7);
        const lang = languageCode.split('-')[0].toLowerCase();
        const link = `https://vibooks.viessmann-climatesolutions.com/${lang}/${lang}?query=${serial}&doctype=vsa`;

        return link;
      })
    );
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
